<template>
  <div class="cashbox-wrap">
    <div :class="{'cashbox-layout': $route.path.includes($paths.cashbox)}">
      <CashboxHeader v-model="isOpenCashboxDropdown" @close-btn-click="() => $refs.modalCloseDepositeRef.open()" />
      <div class="cashbox-layout__content" :class="{'open-save-cards': isOpenSaveCard}">
        <SlidingMenu v-model="isOpenCashboxDropdown" />
        <CashboxNavigation class="cashbox-layout__sidebar" />
        <Transition name="page" mode="out-in">
          <Nuxt class="cashbox-layout__view" />
        </Transition>
      </div>
    </div>

    <ClientOnly>
      <ModalComponent />
    </ClientOnly>

    <ModalCloseDeposite
      ref="modalCloseDepositeRef"
      :min-deposite="calculateMinDeposit | formatNumberFilter"
    />

    <ClientOnly>
      <BaseModalGlobal />
    </ClientOnly>

    <ClientOnly>
      <IntercomLoading />
    </ClientOnly>

    <ClientOnly>
      <NotifyToast />
    </ClientOnly>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { storageService } from '@/services'
import i18nHead from '@/util/i18n/i18nHead'

const BaseModalGlobal = () => import('@/components/Base/Modal/Global')
const IntercomLoading = () => import('@/components/IntercomLoading')
const ModalCloseDeposite = () => import('@/components/Cashbox/Modals/CloseDeposit')
const CashboxNavigation = () => import('@/components/Cashbox/Navigation')
const SlidingMenu = () => import('@/components/Cashbox/Header/SlidingMenu')
const CashboxHeader = () => import('@/components/Cashbox/Header')
const NotifyToast = () => import('@/components/NotifyToast')

export default {
  components: {
    CashboxHeader,
    CashboxNavigation,
    NotifyToast,
    SlidingMenu,
    ModalCloseDeposite,
    BaseModalGlobal,
    IntercomLoading,
  },
  middleware: ['auth'],
  data() {
    return {
      isOpenCashboxDropdown: false,
    }
  },
  head() {
    return {
      title: this.get_seoPage.title,
      ...i18nHead(this.$nuxtI18nHead({ addSeoAttributes: true })),
      bodyAttrs: { class: 'theme-dark' },
      style: [
        {
          hid: 'custom-style',
          cssText: 'body { overflow:hidden; }',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('payments', ['get_depositPayments', 'get_isShowCards']),
    ...mapGetters('seo', ['get_seoPage']),
    paymentMethod() {
      const paymentIndex = this.$route.query.paymentIndex || 0
      return this.get_depositPayments[paymentIndex] || null
    },
    isLoggedIn() {
      return this.$store.getters['user/isLoggedIn']
    },
    user() {
      return this.$store.getters['user/user']
    },
    calculateMinDeposit() {
      if (this.paymentMethod) {
        return this.paymentMethod.amount.min
      }
      return 0
    },
    isOpenSaveCard() {
      return this.$route.path.includes(this.$paths.cashboxDeposit) && this.get_isShowCards
    },
  },
  created() {
    if (process.server) return
    if (this.isLoggedIn) {
      if (!this.$route.path.includes(this.$paths.cashbox)) {
        this.$store.dispatch('profile/DOCUMENT_STATUS')
      }
    }
    if (this.$route.query.backgameurl) {
      const prevPages = JSON.parse(storageService.getItem('prevPages')) || []
      prevPages.push(`/game/${this.$route.query.backgameurl}`)
      storageService.setItem('prevPages', JSON.stringify(prevPages))
    }
  },
  mounted() {
    if (this.isLoggedIn) {
      this.$store.dispatch('user/PROFILE_INFO')
    }
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
